const $ = jQuery;
const $window = $(window);

const initShipInteractive = () => {
  const els = once('ship-interactive', '.p-st-ship-interactive');
  els.forEach((el) => {
    const $wrapper = $(el);

    $wrapper.find('.pst-bubble-image').each(function () {
      const $bubble = $(this);

      // @todo
      // Initialize popovers for each bubble element with specific options:
      // Set popover container to keep them within the ship interactive area,
      // show the popover on hover, enable HTML for rich content, and dynamically
      // adjust placement based on window width (bottom for small screens, right otherwise).
      // Add a delay to the show action for smoother UX, and pull title and content
      // from bubble's associated elements.
      $bubble.popover({
        container: '.p-st-ship-interactive',
        trigger: 'hover',
        html: true,
        placement() {
          if ($(window).width() < 1440) {
            return 'bottom';
          }
          return 'right';
        },
        delay: { show: 300, hide: 0 },
        title: $bubble.find('.pst-popover-title').html(),
        content: $bubble.find('.pst-popover-desc').html(),
      });
    });
  });
};

$window.on('load', () => initShipInteractive());
